import React, { Component } from "react";

import assetSpreadsheetActions from "../../../actions/assetSpreadsheetActions";
import assetSpreadsheetInputFields from "./assetSpreadsheetInputFields";
import generateEntityCreator from "../../../hocs/generateEntityCreator";

class AssetSpreadsheetCreator extends Component {
  componentWillMount() {
    const { initialValues } = this.props;
    const currDate = new Date();

    const initialValues2 = {
      assessorId: 0,
      headersLine: 1,
      sheetName: "Plataforma aberta + assessor",
      headers: {
        name: "Fundo",
        cgeCode: "CGE",
        cnpj: "CNPJ",
        segment: "Segmento",
        category: "Categoria BTG",
        subcategory: "Subcategoria BTG",
        isin: "ISIN",
        topFunds: "Top Funds",
        currency: "Moeda",
        suitabilityBtg: "Suitability BTG",
        management: "Gestão",
        targetAudience: "Público Alvo",
        openForSubscription: "Aberto para Captação",
        investmentPermitted: "Aplicação",
        minimumInvestment: "Aplicação Minima",
        minimumMovement: "Movimentação Minima",
        minimumBalance: "Saldo Minimo",
        liquidity:
          "Liquidez (Cotização + Liquidação dos Recursos Resgatados) D+",
        return36mCdi: "Retorno % do CDI - 36 M",
        return12m: "Retorno Nominal - 12 M",
        return24m: "Retorno Nominal - 24 M",
        return36m: "Retorno Nominal - 36 M",
        volatility12m: "Volatilidade 12 M",
        sharpe12m: "Sharpe 12 M",
        beta12m: "Beta 12 M",
        anbimaClass: "Classificação Anbima",
        cvmClass: "Classificação CVM",
        netWorth: "Patrimônio Líquido",
        roaAdm: "RoA Adm",
        roaPerf: "RoA Perf",
      },
    };
    this.DefaultFormWithProps = generateEntityCreator({
      entityActions: assetSpreadsheetActions,
      returnRoutePath: "asset-spreadsheets-listing",
      fields: assetSpreadsheetInputFields,
      submitLabel: "Importar",
      initialValues: initialValues2,
    });
  }

  render() {
    const { DefaultFormWithProps } = this;
    return <DefaultFormWithProps />;
  }
}

export default AssetSpreadsheetCreator;
